// extracted by mini-css-extract-plugin
export default {"categoryPage":"CategoryProducts_categoryPage__Fc24Q","search":"CategoryProducts_search__QsHuU"};